export const environment = {
    serviceName: '/api',
    blobStorage: 'https://peccerium.blob.core.windows.net/cdr',
    production: true
};
